export default __webpack_public_path__ + "static/media/empty.917c1a3f.svg";